import React from "react";

import { Directory } from "../../features";

const DirectoryPage = () => <Directory />;

export default DirectoryPage;
